import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetUserOrderDetail } from "./service";

export const useGetOrderDetail = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.ORDER_DETAIL, params.order_number],
    queryFn: () =>
      apiGetUserOrderDetail(params).then((res: any) => res.data.data),
    ...options,
  });
};
